import React, { useEffect, useState } from "react";

import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import taxReportApi from "../api/taxReportApi";

function StorageReportPage() {
  const customerInfor = useSelector((state) => state.auth.customerInfor);
  const [openStorageReport, setOpenStorageReport] = useState(false);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  // Tạo mảng năm từ 1900 đến năm hiện tại (đảo ngược để năm mới nhất lên đầu)
  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => 1900 + index,
  ).reverse();
  const getCurrentQuarter = () => Math.floor((new Date().getMonth() + 3) / 3);
  const [quarter, setQuarter] = useState(getCurrentQuarter());
  const quarters = [
    { value: -1, label: "Tất cả" },
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [selectYear, setSelectYear] = useState(currentYear);
  const [selectQuarter, setSelectQuarter] = useState(getCurrentQuarter());

  const fetchReports = async () => {
    try {
      const response = await taxReportApi.GetReportFileByCustomer(
        customerInfor.CusId,
        -1,
        selectYear,
        selectQuarter,
      );
      if (response.success) {
        setFilteredFiles(response.data || []);
      } else toast.error(response.message);
    } catch (error) {
      toast.error(error);
      setFilteredFiles([]);
    }
  };
  const handleDownload = async (file) => {
    try {
      const response = await taxReportApi.DownloadFile(
        customerInfor.CusId,
        file.fileId,
      );
      const binaryData = response.data; // Lấy phần nội dung nhị phân

      if (
        !(binaryData instanceof Blob) &&
        !(binaryData instanceof ArrayBuffer)
      ) {
        toast.error("Lỗi xử lý dữ liệu!");
        console.error("Dữ liệu không phải nhị phân! Kiểm tra responseType.");
      }

      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error);
    }
  };
  const handleDelete = async (file) => {
    try {
      const response = await taxReportApi.DeleteFile(
        customerInfor.CusId,
        file.fileId,
      );
      if (response.success) fetchReports();
      else toast.error(response.message);
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <Grid
      container
      spacing={1}
      sx={{ display: "flex", flexDirection: "column", padding: 2 }}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
          <TextField
            select
            label="Năm"
            fullWidth
            value={selectYear}
            onChange={(e) => setSelectYear(e.target.value)}
            size="small"
            align="center"
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 180,
                  },
                },
              },
            }}
          >
            {years.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
          <TextField
            select
            label="Quý"
            fullWidth
            value={selectQuarter}
            onChange={(e) => setSelectQuarter(e.target.value)}
            size="small"
          >
            {quarters.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid sx={{ minWidth: 150 }}>
          <Button
            variant="contained"
            onClick={fetchReports}
            fullWidth
            size="medium"
          >
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ mt: 2, minHeight: "300px" }}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Danh sách báo cáo ({filteredFiles.length})
        </Typography>

        {filteredFiles.length > 0 ? (
          <List
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              bgcolor: "background.paper",
              maxHeight: 400,
              overflow: "auto",
            }}
          >
            {filteredFiles.map((file, index) => (
              <ListItem
                key={index}
                secondaryAction={
                  <Stack direction="row" spacing={1}>
                    <Tooltip title="Tải về">
                      <IconButton
                        edge="end"
                        color="primary"
                        onClick={() => handleDownload(file)}
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Xóa">
                      <IconButton
                        edge="end"
                        color="info"
                        onClick={() => handleDelete(file)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                    {/* <Tooltip title="Xem chi tiết">
                                      <IconButton
                                        edge="end"
                                        color="info"
                                        onClick={() => handleView(file)}
                                      >
                                        <VisibilityIcon />
                                      </IconButton>
                                    </Tooltip> */}
                  </Stack>
                }
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: "#f44336" }}>
                    <PictureAsPdfIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={file.fileName}
                  secondary={`Ngày tạo: ${dayjs(file.createdAt).format("DD/MM/YYYY HH:mm:ss")}`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box sx={{ textAlign: "center", py: 5 }}>
            <Typography color="textSecondary">
              Không tìm thấy báo cáo nào cho thời gian này.
            </Typography>
          </Box>
        )}
      </Box>
    </Grid>
  );
}

export default StorageReportPage;
